import React from 'react'
import {KTIcon} from '../../../../_metronic/helpers'

interface PreviewDocumentModalHeaderProps {
  setIsPreviewDocumentModalOpen: React.Dispatch<React.SetStateAction<boolean>>
}

const PreviewDocumentModalHeader: React.FC<PreviewDocumentModalHeaderProps> = ({
  setIsPreviewDocumentModalOpen,
}) => {
  return (
    <div className='modal-header'>
      {/* begin::Modal title */}
      <h2 className='fw-bolder'>Previsualizar Documento</h2>
      {/* end::Modal title */}

      {/* begin::Close */}
      <div
        className='btn btn-icon btn-sm btn-active-icon-primary'
        onClick={() => {
          setIsPreviewDocumentModalOpen(false)
        }}
        style={{cursor: 'pointer'}}
      >
        <KTIcon iconName='cross' className='fs-1' />
      </div>
      {/* end::Close */}
    </div>
  )
}

export {PreviewDocumentModalHeader}
